import React from 'react';
import { theme } from 'codeArt/components/Base';
import { DataContext } from './context';
import { data as produce } from './Overview';

//在当前页面的路由表页面进行调用 否则不进行触发调用
export function importData() {
    DataContext.register([
        {
            name: "PERFORMANCE_OVERVIEW_PRODUCE",
            data: produce
        },
        {
            name: "PERFORMANCE_OVERVIEW_OEE",
            data: data
        },
        {
            name: "PRODUCTION_OUTPUT",
            data: PRODUCTION_OUTPUT
        },
        {
            name: "PERFORMANCE_OVERVIEW_SPEED",
            data: PERFORMANCE_OVERVIEW_SPEED
        }
        ,
        {
            name: "PRODUCTION_OEEDAY",
            data: PRODUCTION_OEEDAY
        }
        ,
        {
            name: "PRODUCTION_MTBT",
            data: PRODUCTION_MTBT
        }
        ,
        {
            name: "PRODUCTION_PERFORMANCE",
            data: PRODUCTION_PERFORMANCE
        }
        ,
        {
            name: "PRODUCTION_AVAILABILITY",
            data: PRODUCTION_AVAILABILITY
        }
        ,
        {
            name: "PRODUCTION_QUALITY",
            data: PRODUCTION_QUALITY
        }
        ,
        {
            name: "PRODUCTION_TIMEUTILIZATION",
            data: PRODUCTION_TIMEUTILIZATION
        }
        ,
        {
            name: "PRODUCTION_EFFECT",
            data: PRODUCTION_EFFECT
        }
        ,
        {
            name: "PRODUCTION_OPERATIONHOURS_AREA",
            data: PRODUCTION_OPERATIONHOURS_AREA
        }
        ,
        {
            name: "PRODUCTION_OPERATIONHOURS_DONUT",
            data: PRODUCTION_OPERATIONHOURS_DONUT
        },
        {
            name: "PRODUCTION_STICKTYPE",
            data: PRODUCTION_STICKTYPE
        },
        {
            name: "PRODUCTION_GROUPTEAM",
            data: PRODUCTION_GROUPTEAM
        },
        {
            name: "PRODUCTION_PROPORTION_TYPE",
            data: ({ arg }) => {
                if (!arg) return null;

                return [
                    {
                        outside: [{ value: 672346, name: arg.name }, { value: 1897632, name: '其他类型' }],
                        inside: [{ value: 668765, name: arg.name }, { value: 1880875, name: '其他类型' }]
                    },

                    {
                        outside: [{ value: 785643, name: arg.name }, { value: 1975431, name: '其他类型' }],
                        inside: [{ value: 779653, name: arg.name }, { value: 1963209, name: '其他类型' }]
                    },

                    {
                        outside: [{ value: 719854, name: arg.name }, { value: 1720764, name: '其他类型' }],
                        inside: [{ value: 700987, name: arg.name }, { value: 1710653, name: '其他类型' }]
                    }
                ];
            }
        },
        {
            name: "PRODUCTION_PROPORTION_GROUP",
            data: PRODUCTION_PROPORTION_GROUP
        },
        {
            name: "PRODUCTION_PROPORTION_SHIFT",
            data: PRODUCTION_PROPORTION_SHIFT
        },
    ]);
}

const PRODUCTION_STICKTYPE = [
    [
        {
            name: "爆珠棒",
            totalValue: 324412,
            totalRatio: 0.296,
            qualifiedValue: 318721,
            qualifiedValueRatio: 0.316
        },
        {
            name: "高透棒",
            totalValue: 284144,
            totalRatio: 0.259,
            qualifiedValue: 267234,
            qualifiedValueRatio: 0.248
        },
        {
            name: "中空拉丝棒",
            totalValue: 243552,
            totalRatio: 0.222,
            qualifiedValue: 318721,
            qualifiedValueRatio: 0.316
        },
        {
            name: "二元复合棒",
            totalValue: 162368,
            totalRatio: 0.148,
            qualifiedValue: 159249,
            qualifiedValueRatio: 0.139
        },
        {
            name: "三元复合棒",
            totalValue: 40592,
            totalRatio: 0.037,
            qualifiedValue: 392364,
            qualifiedValueRatio: 0.035
        },
        {
            name: "四元复合棒",
            totalValue: 40592,
            totalRatio: 0.037,
            qualifiedValue: 401232,
            qualifiedValueRatio: 0.039
        }
    ]
];

const PRODUCTION_OPERATIONHOURS_AREA = [
    [7.8, 8.8, 7.5, 9, 8.5],
    [7.2, 8.4, 7.8, 8.8, 8.4],
    [7.8, 7.5, 8.8, 8.4, 8.5],
];

const PRODUCTION_OPERATIONHOURS_DONUT = [
    [
        { name: "运行时间", value: 42, color: theme.color.blue, format: (value, percent) => { return percent; } },
        { name: "停机时间", value: 5.5, color: theme.color.secondary, format: (value, percent) => { return percent; } },
    ],
    [
        { name: "运行时间", value: 46, color: theme.color.blue, format: (value, percent) => { return percent; } },
        { name: "停机时间", value: 5.6, color: theme.color.secondary, format: (value, percent) => { return percent; } },
    ],
    [
        { name: "运行时间", value: 48, color: theme.color.blue, format: (value, percent) => { return percent; } },
        { name: "停机时间", value: 7.8, color: theme.color.secondary, format: (value, percent) => { return percent; } },
    ]
];

const PRODUCTION_OEEDAY = [
    [0.82, 0.89, 0.82, 0.85, 0.88],
    [0.83, 0.85, 0.86, 0.84, 0.89],
    [0.84, 0.89, 0.87, 0.82, 0.91],
];

const PRODUCTION_MTBT = [
    [3.5, 3.65, 3.1, 3.2, 3.4],
    [3.3, 3.4, 3.2, 3.35, 3.5],
    [3.2, 3.35, 3.6, 3.45, 3.2],
];

const PRODUCTION_PERFORMANCE = [
    [0.91, 0.95, 0.90, 0.94, 0.96],
    [0.93, 0.91, 0.95, 0.96, 0.98],
    [0.95, 0.92, 0.96, 0.94, 0.97],
];

const PRODUCTION_AVAILABILITY = [
    [0.83, 0.89, 0.82, 0.85, 0.89],
    [0.85, 0.89, 0.87, 0.82, 0.91],
    [0.82, 0.85, 0.86, 0.84, 0.88],
];

const PRODUCTION_QUALITY = [
    [0.94, 0.92, 0.96, 0.94, 0.97],
    [0.92, 0.91, 0.95, 0.96, 0.98],
    [0.91, 0.95, 0.90, 0.94, 0.96],
];


const PRODUCTION_TIMEUTILIZATION = [
    [0.85, 0.89, 0.87, 0.82, 0.91],
    [0.82, 0.85, 0.86, 0.84, 0.88],
    [0.83, 0.89, 0.82, 0.85, 0.89],
];

const PRODUCTION_EFFECT = [
    [0.85, 0.89, 0.82, 0.85, 0.87],
    [0.84, 0.85, 0.86, 0.84, 0.92],
    [0.83, 0.89, 0.87, 0.82, 0.91],
];

const PERFORMANCE_OVERVIEW_SPEED = [
    [
        [4750, 4500, 5120, 5500, 5300],
        [230, 265, 255, 220, 261]
    ],
    [
        [4340, 4426, 4920, 4723, 5231],
        [234, 262, 254, 225, 258]
    ],
    [
        [4920, 4500, 4340, 4723, 5500],
        [258, 234, 262, 254, 225]
    ],

];

/* const PERFORMANCE_OVERVIEW_OSR = [
    [
        [324567, 423678, 592340, 778901, 823456],
        [262345, 382579, 492145, 652456, 741234],
        [0.75, 0.88, 0.83, 0.92, 0.91]
    ],
    [
        [324457, 423456, 522445, 724561, 813452],
        [274453, 372456, 463247, 682489, 752349],
        [0.78, 0.87, 0.835, 0.86, 0.95]
    ],
    [
        [342241, 453577, 545341, 775934, 886542],
        [251367, 374245, 463567, 683456, 802456],
        [0.76, 0.89, 0.84, 0.93, 0.92]
    ]
];
 */

const PRODUCTION_OUTPUT = [
    [
        [231, 245, 256, 275, 243, 259, 234],
        [226, 236, 241, 261, 235, 246, 224],
        [0.978, 0.963, 0.941, 0.949, 0.967, 0.949, 0.957]
    ]
];

const PRODUCTION_GROUPTEAM = [
    {outside:[{ value: 1101234, name: '甲班' },{ value: 1334532, name: '乙班' }],
    inside:[{ value: 1095678, name: '甲班' },{ value: 1318765, name: '乙班' }]},

    {outside:[{ value: 1429876, name: '甲班' },{ value: 1174532, name: '乙班' }],
    inside:[{ value: 1410099, name: '甲班' },{ value: 1159876, name: '乙班' }]},

    {outside:[{ value: 1112367, name: '甲班' },{ value: 1235678, name: '乙班' }],
    inside:[{ value: 1105643, name: '甲班' },{ value: 1220087, name: '乙班' }]}
];


const PRODUCTION_PROPORTION_GROUP = [
    {outside:[{ value: 418765, name: '甲班' },{ value: 401876, name: '乙班' }],
    inside:[{ value: 409654, name: '甲班' },{ value: 390765, name: '乙班' }]},

    {outside:[{ value: 398764, name: '甲班' },{ value: 410987, name: '乙班' }],
    inside:[{ value: 390765, name: '甲班' },{ value: 407896, name: '乙班' }]},

    {outside:[{ value: 420985, name: '甲班' },{ value: 409765, name: '乙班' }],
    inside:[{ value: 415678, name: '甲班' },{ value: 401234, name: '乙班' }]}
];

const PRODUCTION_PROPORTION_SHIFT = [
    {outside:[{ value: 219865, name: '早班' },{ value: 226549, name: '中班' },{ value: 231234, name: '晚班' }],
    inside:[{ value: 206543, name: '早班' },{ value: 216578, name: '中班' },{ value: 228756, name: '晚班' }]},

    {outside:[{ value: 247654, name: '早班' },{ value: 227548, name: '中班' },{ value: 219764, name: '晚班' }],
    inside:[{ value: 230134, name: '早班' },{ value: 219432, name: '中班' },{ value: 210987, name: '晚班' }]},

    {outside:[{ value: 231234, name: '早班' },{ value: 210876, name: '中班' },{ value: 249657, name: '晚班' }],
    inside:[{ value: 225642, name: '早班' },{ value: 209875, name: '中班' },{ value: 230876, name: '晚班' }]}
];

const Suite01_Shift0 = {
    equipment: "L01",//设备
    OEE: 89.66, //OEE
    performance: 98.44, //性能
    availability: 86.47, //可用性
    quality: 99.51, //质量
    outputMinute: 854381,//生产
    actualSpeed: 1698, //实际速度
    planningSpeed: 1700, //计划速度
    operationHours: "02:54.26",
    plannedTime: "03:21.26",
    totalProduction: 858560,
    output: 854381,
    scrap: 4179,
}

const Suite01_Shift1 = {
    equipment: "L01",//设备
    OEE: 88.36, //OEE
    performance: 96.41, //性能
    availability: 87.37, //可用性
    quality: 99.41, //质量
    outputMinute: 854351,//生产
    actualSpeed: 1658, //实际速度
    planningSpeed: 1700, //计划速度
    operationHours: "02:51.26",
    plannedTime: "03:11.26",
    totalProduction: 818360,
    output: 852381,
    scrap: 4175,
}

const Suite01_Shift2 = {
    equipment: "L01",//设备
    OEE: 17.55, //OEE
    performance: 22.66, //性能
    availability: 86.47, //可用性
    quality: 99.51, //质量
    outputMinute: 32432,//生产
    actualSpeed: 1532, //实际速度
    planningSpeed: 1500, //计划速度
    operationHours: "04:22.26",
    plannedTime: "12:12.26",
    totalProduction: 324,
    output: 32423423,
    scrap: 234,
}

const Suite01_Shift3 = {
    equipment: "L01",//设备
    OEE: 23.36, //OEE
    performance: 45.41, //性能
    availability: 65.37, //可用性
    quality: 65.41, //质量
    outputMinute: 43545,//生产
    actualSpeed: 1562, //实际速度
    planningSpeed: 1500, //计划速度
    operationHours: "13:56.26",
    plannedTime: "15:22.26",
    runTime: 0.78,
    stopTime: 0.22,
    totalProduction: 343243,
    output: 65776578,
    scrap: 231,
}

const Suite02_Shift0 = {
    equipment: "L02",//设备
    OEE: 86.56, //OEE
    performance: 95.41, //性能
    availability: 82.27, //可用性
    quality: 98.41, //质量
    outputMinute: 854251,//生产
    actualSpeed: 1555, //实际速度
    planningSpeed: 1500, //计划速度
    operationHours: "03:41.26",
    plannedTime: "04:14.26",
    runTime: 0.85,
    stopTime: 0.15,
    totalProduction: 814310,
    output: 842251,
    scrap: 4276,
}

const Suite02_Shift1 = {
    equipment: "L02",//设备
    OEE: 89.56, //OEE
    performance: 96.41, //性能
    availability: 86.23, //可用性
    quality: 97.31, //质量
    outputMinute: 854256,//生产
    actualSpeed: 1445, //实际速度
    planningSpeed: 1400, //计划速度
    operationHours: "02:36.26",
    plannedTime: "04:13.21",
    runTime: 0.82,
    stopTime: 0.18,
    totalProduction: 814355,
    output: 842426,
    scrap: 4376,
}

const Suite02_Shift2 = {
    equipment: "L02",//设备
    OEE: 23.56, //OEE
    performance: 99.41, //性能
    availability: 56.27, //可用性
    quality: 99.41, //质量
    outputMinute: 34543,//生产
    actualSpeed: 1534, //实际速度
    planningSpeed: 1500, //计划速度
    operationHours: "06:22.26",
    plannedTime: "07:11.26",
    runTime: 0.89,
    stopTime: 0.11,
    totalProduction: 3242432,
    output: 768786787,
    scrap: 1232,
}

const Suite02_Shift3 = {
    equipment: "L02",//设备
    OEE: 99.56, //OEE
    performance: 98.41, //性能
    availability: 78.23, //可用性
    quality: 93.31, //质量
    outputMinute: 3453,//生产
    actualSpeed: 1542, //实际速度
    planningSpeed: 1500, //计划速度
    operationHours: "12:56.26",
    plannedTime: "66:13.21",
    runTime: 0.21,
    stopTime: 0.79,
    totalProduction: 324324,
    output: 123324,
    scrap: 5677,
}

const Suite03_Shift0 = {
    equipment: "L03",//设备
    OEE: 91.56, //OEE
    performance: 97.41, //性能
    availability: 84.23, //可用性
    quality: 95.21, //质量
    outputMinute: 834236,//生产
    actualSpeed: 1425, //实际速度
    planningSpeed: 1500, //计划速度
    operationHours: "03:32.26",
    plannedTime: "04:12.25",
    runTime: 0.86,
    stopTime: 0.14,
    totalProduction: 814365,
    output: 842423,
    scrap: 4374,
}

const Suite03_Shift1 = {
    equipment: "L03",//设备
    OEE: 89.56, //OEE
    performance: 95.41, //性能
    availability: 85.23, //可用性
    quality: 92.21, //质量
    outputMinute: 824236,//生产
    actualSpeed: 1655, //实际速度
    planningSpeed: 1700, //计划速度
    operationHours: "03:32.26",
    plannedTime: "04:12.25",
    runTime: 0.86,
    stopTime: 0.14,
    totalProduction: 814365,
    output: 842443,
    scrap: 4375,
}

const Suite03_Shift2 = {
    equipment: "L03",//设备
    OEE: 78.56, //OEE
    performance: 67.41, //性能
    availability: 55.23, //可用性
    quality: 99.21, //质量
    outputMinute: 3453543,//生产
    actualSpeed: 1700, //实际速度
    planningSpeed: 1700, //计划速度
    operationHours: "12:32.26",
    plannedTime: "56:12.25",
    runTime: 0.11,
    stopTime: 0.89,
    totalProduction: 4353435,
    output: 12313,
    scrap: 3424,
}

const Suite03_Shift3 = {
    equipment: "L03",//设备
    OEE: 23.56, //OEE
    performance: 234.41, //性能
    availability: 234.23, //可用性
    quality: 56.21, //质量
    outputMinute: 324234,//生产
    actualSpeed: 1750, //实际速度
    planningSpeed: 1800, //计划速度
    operationHours: "11:32.26",
    plannedTime: "12:12.25",
    runTime: 0.91,
    stopTime: 0.09,
    totalProduction: 324234,
    output: 234324,
    scrap: 2343,
}

const Suite04_Shift0 = {
    equipment: "L04",//设备
    OEE: 92.56, //OEE
    performance: 96.41, //性能
    availability: 85.23, //可用性
    quality: 96.21, //质量
    outputMinute: 833236,//生产
    actualSpeed: 1600, //实际速度
    planningSpeed: 1650, //计划速度
    operationHours: "03:56.26",
    plannedTime: "04:15.25",
    runTime: 0.87,
    stopTime: 0.13,
    totalProduction: 814365,
    output: 842443,
    scrap: 4323,
}

const Suite04_Shift1 = {
    equipment: "L04",//设备
    OEE: 82.56, //OEE
    performance: 95.21, //性能
    availability: 83.43, //可用性
    quality: 96.07, //质量
    outputMinute: 854236,//生产
    actualSpeed: 1700, //实际速度
    planningSpeed: 1750, //计划速度
    operationHours: "03:01.26",
    plannedTime: "03:14.25",
    runTime: 0.97,
    stopTime: 0.03,
    totalProduction: 824365,
    output: 843423,
    scrap: 4375,
}

const Suite04_Shift2 = {
    equipment: "L04",//设备
    OEE: 99.56, //OEE
    performance: 89.41, //性能
    availability: 78.23, //可用性
    quality: 91.21, //质量
    outputMinute: 2341324,//生产
    actualSpeed: 1800, //实际速度
    planningSpeed: 1850, //计划速度
    operationHours: "12:56.26",
    plannedTime: "33:15.25",
    runTime: 0.32,
    stopTime: 0.68,
    totalProduction: 213412,
    output: 234343,
    scrap: 2334,
}

const Suite04_Shift3 = {
    equipment: "L04",//设备
    OEE: 76.56, //OEE
    performance: 89.21, //性能
    availability: 88.43, //可用性
    quality: 92.07, //质量
    outputMinute: 232121,//生产
    actualSpeed: 1650, //实际速度
    planningSpeed: 1600, //计划速度
    operationHours: "13:01.26",
    plannedTime: "14:14.25",
    runTime: 0.84,
    stopTime: 0.16,
    totalProduction: 824365,
    output: 843423,
    scrap: 4375,
}

const Suite05_Shift0 = {
    equipment: "L05",//设备
    OEE: 92.56, //OEE
    performance: 96.41, //性能
    availability: 85.23, //可用性
    quality: 94.25, //质量
    outputMinute: 844236,//生产
    actualSpeed: 1600, //实际速度
    planningSpeed: 1700, //计划速度
    operationHours: "03:32.26",
    plannedTime: "04:12.25",
    runTime: 0.86,
    stopTime: 0.14,
    totalProduction: 812365,
    output: 842425,
    scrap: 4375,
}

const Suite05_Shift1 = {
    equipment: "L05",//设备
    OEE: 91.56, //OEE
    performance: 95.41, //性能
    availability: 82.23, //可用性
    quality: 96.21, //质量
    outputMinute: 834236,//生产
    actualSpeed: 1750, //实际速度
    planningSpeed: 1750, //计划速度
    operationHours: "03:32.26",
    plannedTime: "04:12.25",
    runTime: 0.86,
    stopTime: 0.14,
    totalProduction: 812365,
    output: 842424,
    scrap: 4374,
}

const Suite05_Shift2 = {
    equipment: "L05",//设备
    OEE: 78.56, //OEE
    performance: 34.41, //性能
    availability: 56.23, //可用性
    quality: 99.25, //质量
    outputMinute: 844236,//生产
    actualSpeed: 1700, //实际速度
    planningSpeed: 1680, //计划速度
    operationHours: "15:32.26",
    plannedTime: "16:12.25",
    runTime: 0.87,
    stopTime: 0.13,
    totalProduction: 812365,
    output: 842425,
    scrap: 4375,
}

const Suite05_Shift3 = {
    equipment: "L05",//设备
    OEE: 93.56, //OEE
    performance: 94.41, //性能
    availability: 81.23, //可用性
    quality: 95.21, //质量
    outputMinute: 32432,//生产
    actualSpeed: 1680, //实际速度
    planningSpeed: 1700, //计划速度
    operationHours: "15:32.26",
    plannedTime: "16:12.25",
    runTime: 0.87,
    stopTime: 0.13,
    totalProduction: 812365,
    output: 842424,
    scrap: 4374,
}

const Suite06_Shift0 = {
    equipment: "L06",//设备
    OEE: 84.56, //OEE
    performance: 96.41, //性能
    availability: 82.23, //可用性
    quality: 93.25, //质量
    outputMinute: 844236,//生产
    actualSpeed: 1700, //实际速度
    planningSpeed: 1750, //计划速度
    operationHours: "03:32.26",
    plannedTime: "04:12.25",
    runTime: 0.86,
    stopTime: 0.14,
    totalProduction: 824365,
    output: 842425,
    scrap: 4374,
}

const Suite06_Shift1 = {
    equipment: "L06",//设备
    OEE: 87.56, //OEE
    performance: 95.41, //性能
    availability: 83.23, //可用性
    quality: 94.25, //质量
    outputMinute: 753236,//生产
    actualSpeed: 1500, //实际速度
    planningSpeed: 1500, //计划速度
    operationHours: "03:09.21",
    plannedTime: "04:06.25",
    runTime: 0.8,
    stopTime: 0.2,
    totalProduction: 824365,
    output: 844423,
    scrap: 4371,
}

const Suite06_Shift2 = {
    equipment: "L06",//设备
    OEE: 12.56, //OEE
    performance: 34.41, //性能
    availability: 56.23, //可用性
    quality: 78.25, //质量
    outputMinute: 2344234,//生产
    actualSpeed: 1555, //实际速度
    planningSpeed: 1600, //计划速度
    operationHours: "17:32.26",
    plannedTime: "18:12.25",
    runTime: 0.86,
    stopTime: 0.14,
    totalProduction: 342343,
    output: 34324324,
    scrap: 1234,
}

const Suite06_Shift3 = {
    equipment: "L06",//设备
    OEE: 34.56, //OEE
    performance: 56.41, //性能
    availability: 78.23, //可用性
    quality: 94.25, //质量
    outputMinute: 3243245,//生产
    actualSpeed: 1710, //实际速度
    planningSpeed: 1750, //计划速度
    operationHours: "09:09.21",
    plannedTime: "10:06.25",
    runTime: 0.87,
    stopTime: 0.13,
    totalProduction: 325432,
    output: 43535,
    scrap: 4371,
}

const Suite07_Shift0 = {
    equipment: "L07",//设备
    OEE: 91.32, //OEE
    performance: 96.56, //性能
    availability: 86.33, //可用性
    quality: 96.32, //质量
    outputMinute: 854236,//生产
    actualSpeed: 1875, //实际速度
    planningSpeed: 1900, //计划速度
    operationHours: "03:45.26",
    plannedTime: "04:56.25",
    runTime: 0.86,
    stopTime: 0.14,
    totalProduction: 854365,
    output: 842433,
    scrap: 4371,
}

const Suite07_Shift1 = {
    equipment: "L07",//设备
    OEE: 91.23, //OEE
    performance: 96.41, //性能
    availability: 85.23, //可用性
    quality: 96.25, //质量
    outputMinute: 836236,//生产
    actualSpeed: 1680, //实际速度
    planningSpeed: 1650, //计划速度
    operationHours: "02:21.26",
    plannedTime: "03:14.25",
    runTime: 0.76,
    stopTime: 0.24,
    totalProduction: 852365,
    output: 824423,
    scrap: 4472,
}

const Suite07_Shift2 = {
    equipment: "L07",//设备
    OEE: 56.32, //OEE
    performance: 87.56, //性能
    availability: 89.33, //可用性
    quality: 96.32, //质量
    outputMinute: 854236,//生产
    actualSpeed: 1800, //实际速度
    planningSpeed: 1830, //计划速度
    operationHours: "08:45.26",
    plannedTime: "09:56.25",
    runTime: 0.79,
    stopTime: 0.21,
    totalProduction: 5465546,
    output: 456546,
    scrap: 4371,
}

const Suite07_Shift3 = {
    equipment: "L07",//设备
    OEE: 89.23, //OEE
    performance: 99.41, //性能
    availability: 87.23, //可用性
    quality: 93.25, //质量
    outputMinute: 3453534,//生产
    actualSpeed: 1670, //实际速度
    planningSpeed: 1700, //计划速度
    operationHours: "06:21.26",
    plannedTime: "07:14.25",
    runTime: 0.77,
    stopTime: 0.23,
    totalProduction: 35435643,
    output: 4354354,
    scrap: 4567,
}

export const data = [
    {
        ...Suite01_Shift0
    },
    {
        ...Suite01_Shift1
    },
    {
        ...Suite01_Shift2
    },
    {
        ...Suite01_Shift3
    },
    {
        ...Suite02_Shift0
    },
    {
        ...Suite02_Shift1
    },
    {
        ...Suite02_Shift2
    },
    {
        ...Suite02_Shift3
    }
    ,
    {
        ...Suite03_Shift0
    },
    {
        ...Suite03_Shift1
    },
    {
        ...Suite03_Shift2
    },
    {
        ...Suite03_Shift3
    },
    {
        ...Suite04_Shift0
    },
    {
        ...Suite04_Shift1
    },
    {
        ...Suite04_Shift2
    },
    {
        ...Suite04_Shift3
    },
    {
        ...Suite05_Shift0
    },
    {
        ...Suite05_Shift1
    },
    {
        ...Suite05_Shift2
    },
    {
        ...Suite05_Shift3
    },
    {
        ...Suite06_Shift0
    },
    {
        ...Suite06_Shift1
    },
    {
        ...Suite06_Shift2
    },
    {
        ...Suite06_Shift3
    },
    {
        ...Suite07_Shift0
    },
    {
        ...Suite07_Shift1
    },
    {
        ...Suite07_Shift2
    },
    {
        ...Suite07_Shift3
    },
];
